import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ContourMap, ContourMapDirective } from '../../directives/contour-map/contour-map.directive';
import { DashboardNavComponent } from '../dashboard-nav/dashboard-nav.component';
import { SidebarFooterComponent } from '../sidebar-footer/sidebar-footer.component';

/**
 * The terrain in the sidebar's foot. Quieter than the hero's — this is the dark wood the console
 * rests on, not a headline: fewer systems, a shorter step, and no routes threaded between them.
 */
const SIDE_MAP: ContourMap = {
  step: 22,
  alphaBase: 0.1,
  alphaFade: 0.014,
  centers: [
    { x: 0.28, y: 0.92, seed: 2.4, rings: 5 },
    { x: 0.95, y: 0.55, seed: 6.7, rings: 4 },
  ],
};

/**
 * The desktop dashboard's sidebar: brand, nav and profile.
 *
 * The app shell renders it as a sibling BEFORE `<main>`, never the dashboard layout inside it. The
 * layout used to draw it next to its own outlet, which put the whole sidebar inside the `<main>`
 * landmark: a skip link to the page content would have landed before the nav it exists to skip.
 * Whether it shows is still the layout's call (`ConsoleShellService.hasSidebar`, read through
 * `App.isSidebarVisible`), so it comes and goes with the dashboard routes exactly as before.
 */
@Component({
  selector: 'app-dashboard-sidebar',
  imports: [RouterLink, DashboardNavComponent, SidebarFooterComponent, ContourMapDirective],
  templateUrl: './dashboard-sidebar.component.html',
  styleUrl: './dashboard-sidebar.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'dashboard-sidebar',
  },
})
export class DashboardSidebarComponent {
  protected readonly sideMap = SIDE_MAP;
}
